module.exports = __webpack_public_path__ + "img/5dd8a8d9ff9d4894a5a4caa59b60855f_mergeImage.fc4a9fd0.png";